module.exports = __webpack_public_path__ + "static/media/profile-benita-zahn.33c7c0da.jpg";